import Hook from './Hook';

/**
 * 同步地注册函数，并在调用时依次执行。
 * 并且前一个函数的返回值将作为后一个函数的参数。（注：函数默认有隐式的返回值 undefined）
 */
export default class SyncWaterfallHook extends Hook {
  call(args: any) {
    if (this.hookFns.length === 0) return args;

    const [first, ...others] = this.hookFns;
    const ret = first(args);
    return others.reduce((a, b) => b(a), ret);
  }
}
